// Summaries are restricted to the received post-session rows, never all study activity.
export const usableSummary = row => {
  const s = row.engagementVisible === true ? row.summary : null;
  return s && Number.isInteger(s.total) && s.total > 0 && Number.isInteger(s.answered)
    && s.answered >= 0 && s.answered <= s.total ? s : null;
};
export const scoredSummary = row => {
  const s = usableSummary(row);
  return row.state === 'COMPLETED' && s && Number.isInteger(s.correct)
    && s.correct >= 0 && s.correct <= s.answered ? s : null;
};
export const matchesStatus = (row, status) => {
  if (status === 'all') return true;
  if (status === 'NOT_STARTED') return row.engagementVisible === true && ['SENT', 'OPENED'].includes(row.state);
  if (status === 'IN_PROGRESS') return row.engagementVisible === true && row.state === 'CLAIMED';
  return row.state === status;
};
export const summaryFor = rows => rows.reduce((sum, row) => {
  if (row.engagementVisible !== true) return sum;
  sum.known++;
  if (row.state === 'COMPLETED') sum.completed++;
  if (['SENT', 'OPENED', 'CLAIMED'].includes(row.state)) sum.outstanding++;
  const s = usableSummary(row), score = scoredSummary(row);
  if (row.state === 'COMPLETED' && s) sum.answered += s.answered;
  if (score) { sum.correct += score.correct; sum.total += score.total; sum.scored++; }
  return sum;
}, { known: 0, completed: 0, outstanding: 0, answered: 0, correct: 0, total: 0, scored: 0 });

export const weeklyResults = rows => {
  const weeks = new Map();
  rows.forEach(row => {
    const s = usableSummary(row);
    if (row.engagementVisible !== true || row.state !== 'COMPLETED' || !/^\d{4}-\d{2}-\d{2}T.*Z$/.test(row.completedAt || '')) return;
    const day = new Date(row.completedAt);
    if (Number.isNaN(day.getTime())) return;
    // Same local timezone as the dashboard dates; Monday starts the week.
    day.setHours(0, 0, 0, 0); day.setDate(day.getDate() - (day.getDay() + 6) % 7);
    const key = day.getTime();
    if (!weeks.has(key)) weeks.set(key, { date: day, quizzes: 0, recorded: 0, answered: 0, total: 0, correct: 0, scored: 0 });
    const week = weeks.get(key), score = scoredSummary(row);
    week.quizzes++;
    if (s) { week.recorded++; week.answered += s.answered; }
    if (score) { week.total += score.total; week.correct += score.correct; week.scored++; }
  });
  return [...weeks.values()].sort((a, b) => b.date - a.date);
};
export const recurringTopics = rows => {
  const topics = new Map();
  rows.forEach(row => {
    const s = scoredSummary(row);
    if (!s) return;
    Object.entries(s.missedTopics || {}).forEach(([topic, missed]) => {
      if (!topic.trim() || !Number.isInteger(missed) || missed <= 0 || missed > s.answered) return;
      const value = topics.get(topic) || { topic, missed: 0, quizzes: 0 };
      value.missed += missed; value.quizzes++; topics.set(topic, value);
    });
  });
  return [...topics.values()].filter(value => value.quizzes >= 2)
    .sort((a, b) => b.quizzes - a.quizzes || b.missed - a.missed || a.topic.localeCompare(b.topic)).slice(0, 3);
};
